// @vendor
const React = require('react');
const PropTypes = require('prop-types');

class HireSuccessStepCardImage extends React.Component {

    render() {
        const { 
            className,
            immImageData,
        } = this.props;
        let imageCard = null;

        if (!!immImageData && !!immImageData.toJS && !!immImageData.get('url')) {
            imageCard = (
                <img
                    alt={immImageData.get('alt')}
                    className={className}
                    src={immImageData.get('url')}
                />
            );
        }
    
        return imageCard;
    }
}

HireSuccessStepCardImage.propTypes = {
    className: PropTypes.string.isRequired,
    immImageData: PropTypes.object.isRequired,
};

module.exports = HireSuccessStepCardImage;
